import logoutUser from "@/utils/logoutUser";
import { parseCurrencyObjectToOptions } from "@/utils/parseListingOptions";
import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";
import i18next from "i18next";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: localStorage.getItem("token") || null,
    userId: localStorage.getItem("userId") || null,
    isLogin: Boolean(localStorage.getItem("token")),
    loading: false,
    error: null,
    signupLoading: false,
    rolesLoading: false,
    rolesError: null,
    roles: null,
    forgotLoading: false,
    resetPasswordLoading: false,
    userLat: null,
    userLon: null,
    currencyRateList: null,
    currencyRateListOptions: null,
    selectedCurrency: localStorage.getItem("currency") || "USD",
    selectedCurrencyRate: null
  },
  reducers: {
    // Login actions
    loginRequest: (state) => {
      state.isLogin = false;
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      const { token, uuid } = action.payload;
      state.token = token;
      state.userId = uuid;
      state.isLogin = true;
      state.loading = false;
      state.error = null;
      localStorage.setItem("token", token);
      localStorage.setItem("userId", uuid);
    },
    loginFailure: (state, action) => {
      state.error = action.payload?.response?.data?.message;
      state.loading = false;
      state.isLogin = false;
      state.token = null;
      state.userId = null;
      notification.error({
        message: i18next.t("login.loginFailed"),
        description: action.payload?.response?.data?.message,
        placement: "topRight"
      });
    },
    googleLoginRequest: () => {},
    googleLoginSuccess: () => {},
    googleLoginFailure: (state, action) => {
      state.error = [action.payload.message];
      state.loading = false;
    },
    logout: (state, action) => {
      state.token = null;
      state.isLogin = false;
      logoutUser(action?.payload?.message);
      if (action?.payload?.reload) {
        window.location.reload();
      }
    },

    // Signup actions
    signupRequest: (state) => {
      state.signupLoading = true;
    },
    signupSuccess: (state) => {
      state.signupLoading = false;
      notification.success({
        message: i18next.t("signUp.successTitle"),
        description: i18next.t("signUp.successDescription"),
        placement: "topRight"
      });
    },
    signupFailure: (state, action) => {
      state.error = action.payload.response.data.message;
      state.signupLoading = false;
      notification.error({
        message: i18next.t("signUp.failedTitle"),
        description: action.payload.response.data.message,
        placement: "topRight"
      });
    },
    //Cooperate User Roles
    userRolesRequest: (state) => {
      state.rolesLoading = true;
      state.roles = null;
    },
    userRolesSuccess: (state, action) => {
      state.rolesLoading = false;
      state.roles = action.payload;
    },
    userRolesFailure: (state, action) => {
      state.rolesError = action.payload;
      state.rolesLoading = false;
    },
    //  forgot password
    forgotPasswordRequest: (state) => {
      state.error = null;
      state.forgotLoading = true;
    },
    forgotPasswordSuccess: (state) => {
      state.forgotLoading = false;
    },
    forgotPasswordFailure: (state, action) => {
      state.error = action.payload?.response?.data?.message;
      state.forgotLoading = false;
    },
    resetError: (state) => {
      state.error = null;
    },
    // reset password
    resetPasswordRequest: (state) => {
      state.error = null;
      state.resetPasswordLoading = true;
    },
    resetPasswordSuccess: (state) => {
      state.resetPasswordLoading = false;
    },
    resetPasswordFailure: (state, action) => {
      state.error = action.payload?.response?.data?.message;
      state.resetPasswordLoading = false;
    },

    userLocationRequest: (state) => {
      state.userLat = null;
      state.userLon = null;
    },
    userLocationSuccess: (state, action) => {
      state.userLat = Number(action.payload.latitude);
      state.userLon = Number(action.payload.longitude);
    },
    userLocationFailure: (state, action) => {
      state.error = action.payload;
    },
    currencyRateListRequest: () => {},
    currencyRateListSuccess: (state, action) => {
      const options = action.payload;
      state.currencyRateList = options;
      state.currencyRateListOptions = parseCurrencyObjectToOptions(options);
    },
    currencyRateListFailure: (state, action) => {
      state.error = action.payload;
    },
    changeSelectedCurrency: (state, action) => {
      state.selectedCurrency = action.payload;
      state.selectedCurrencyRate = state.currencyRateList[action.payload];
    }
  }
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  googleLoginRequest,
  googleLoginSuccess,
  googleLoginFailure,
  logout,
  signupRequest,
  signupSuccess,
  signupFailure,
  userRolesRequest,
  userRolesSuccess,
  userRolesFailure,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  resetError,
  resetPasswordRequest,
  resetPasswordSuccess,
  resetPasswordFailure,
  userLocationRequest,
  userLocationSuccess,
  userLocationFailure,
  currencyRateListRequest,
  currencyRateListSuccess,
  currencyRateListFailure,
  changeSelectedCurrency
} = authSlice.actions;

export default authSlice.reducer;
